var render = function () {
  var _vm$me, _vm$me$cash, _vm$me$cash$format, _vm$giftcard$content, _vm$giftcard$content$;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "760",
      "scrollable": ""
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.giftcard && _vm.show ? _c('v-card', {
    staticClass: "v-card--dialog"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("상품문의")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "v-card--dialog__body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "border"
  }, [_c('v-img', {
    attrs: {
      "src": "https://daehanbooksgiftcard.com" + _vm.giftcard.thumb,
      "max-width": "100%",
      "aspect-ratio": 1 / 1,
      "contain": ""
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "tit-wrap mb-20px mb-md-30px"
  }, [_c('h2', {
    staticClass: "tit tit--sm primary--text"
  }, [_vm._v(_vm._s(_vm.giftcard.name))])]), _c('div', {
    staticClass: "font-size-14"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("수량")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', [_c('p', {
    staticClass: "font-size-12 font-size-md-14 primary--text mt-6px"
  }, [_vm._v(_vm._s(_vm.quantityText))]), _vm.giftcard.mode == 'mobile' ? _c('v-select', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "items": _vm.limits
    },
    model: {
      value: _vm.order.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "quantity", $$v);
      },
      expression: "order.quantity"
    }
  }) : _c('v-text-field', {
    attrs: {
      "outlined": "",
      "rules": _vm.quantityRules
    },
    model: {
      value: _vm.order.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "quantity", $$v);
      },
      expression: "order.quantity"
    }
  })], 1)])], 1), _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("보유캐시")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('p', {
    staticClass: "font-weight-medium"
  }, [_c('b', {
    staticClass: "font-size-16 font-size-md-20"
  }, [_vm._v(_vm._s((_vm$me = _vm.me) === null || _vm$me === void 0 ? void 0 : (_vm$me$cash = _vm$me.cash) === null || _vm$me$cash === void 0 ? void 0 : (_vm$me$cash$format = _vm$me$cash.format) === null || _vm$me$cash$format === void 0 ? void 0 : _vm$me$cash$format.call(_vm$me$cash)))]), _vm._v(" 캐시")])])], 1), _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("사용캐시")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "font-weight-medium"
  }, [_c('b', {
    staticClass: "font-size-16 font-size-md-20"
  }, [_vm._v(_vm._s(parseInt((_vm.giftcard.faceamt * _vm.giftcard[_vm.me.riskManagement.giftcard.level + "Commission"] / 100 + _vm.giftcard.faceamt) * _vm.order.quantity).format()))]), _vm._v(" 캐시")]), _c('p', {
    staticClass: "font-size-12 font-size-md-14 primary--text mt-6px"
  }, [_vm._v("(해당 상품은 구매 금액의 " + _vm._s(_vm.giftcard[_vm.me.riskManagement.giftcard.level + "Commission"]) + "% 수수료가 부과됩니다.)")])])])], 1), _vm.giftcard.mode == 'mobile' && !_vm.$vuetify.breakpoint.mobile ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("발송전화번호")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "items": _vm.phones
    },
    model: {
      value: _vm.defaultItem.receiver.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.defaultItem.receiver, "phone1", $$v);
      },
      expression: "defaultItem.receiver.phone1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    model: {
      value: _vm.defaultItem.receiver.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.defaultItem.receiver, "phone2", $$v);
      },
      expression: "defaultItem.receiver.phone2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    ref: "phone3",
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    model: {
      value: _vm.defaultItem.receiver.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.defaultItem.receiver, "phone3", $$v);
      },
      expression: "defaultItem.receiver.phone3"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.phoneReset
    }
  }, [_vm._v("mdi-close")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.giftcard.mode == 'mobile' && _vm.$vuetify.breakpoint.mobile ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("발송"), _c('br'), _vm._v("전화번호")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "clearable": "",
      "maxlength": "13"
    },
    model: {
      value: _vm.order.receiver.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "phone", $$v);
      },
      expression: "order.receiver.phone"
    }
  })], 1)], 1) : _vm._e(), _vm.giftcard.mode == 'paper' ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("받는분")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.receiver.name,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "name", $$v);
      },
      expression: "order.receiver.name"
    }
  })], 1)], 1) : _vm._e(), _vm.giftcard.mode == 'paper' ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("전화번호")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.order.receiver.phone = _vm.order.receiver.phone.replace(/[^0-9]/g, '');
      }
    },
    model: {
      value: _vm.order.receiver.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "phone", $$v);
      },
      expression: "order.receiver.phone"
    }
  })], 1)], 1) : _vm._e(), _vm.giftcard.mode == 'paper' ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("이메일")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.receiver.email,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "email", $$v);
      },
      expression: "order.receiver.email"
    }
  })], 1)], 1) : _vm._e(), _vm.giftcard.mode == 'paper' ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("우편번호")]), _c('v-col', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.shippingAddress.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.order.shippingAddress, "postcode", $$v);
      },
      expression: "order.shippingAddress.postcode"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "pa-3 ml-1",
    attrs: {
      "color": "primary",
      "height": "38",
      "min-width": "auto"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-magnify")])], 1)], 1)], 1) : _vm._e(), _vm.giftcard.mode == 'paper' ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("주소")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.shippingAddress.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.order.shippingAddress, "address1", $$v);
      },
      expression: "order.shippingAddress.address1"
    }
  })], 1)], 1) : _vm._e(), _vm.giftcard.mode == 'paper' ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("상세주소")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.shippingAddress.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.order.shippingAddress, "address2", $$v);
      },
      expression: "order.shippingAddress.address2"
    }
  })], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "mt-16px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "block": "",
      "arge": "",
      "color": "primary"
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("결제하기")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "block": "",
      "arge": "",
      "color": "grey"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("취소")])], 1)], 1)], 1)], 1)])], 1), _c('div', {
    staticClass: "mt-30px"
  }, [_c('div', {
    staticClass: "grey lighten-4 pa-12px"
  }, [_c('p', {
    staticClass: "font-size-14 font-size-md-16",
    domProps: {
      "innerHTML": _vm._s((_vm$giftcard$content = _vm.giftcard.content) === null || _vm$giftcard$content === void 0 ? void 0 : (_vm$giftcard$content$ = _vm$giftcard$content.replace) === null || _vm$giftcard$content$ === void 0 ? void 0 : _vm$giftcard$content$.call(_vm$giftcard$content, /\n/g, '<br>'))
    }
  })])])], 1)]) : _vm._e(), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "input": function input(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        _vm.order.shippingAddress.postcode = postcode;
        _vm.order.shippingAddress.address1 = address;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }